import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ResellerService } from '@services/reseller.service';
import { creditsTypeIcon } from '@utils/constants';
import { SmsService } from '@services/sms.service';
import { ContactService } from '@services/contact.service';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { SmsTemplate } from '@models/sms/templates';
import { Location } from '@angular/common';
import { Blocklist } from '@models/contact/blocklist';
import { ContactGroups } from '@models/contact/group';
import { ResellerProfile } from '@models/reseller/profile';
import { User } from '@models/user';
import { AtlasToastService } from '@services/atlas-toast.service';
import { AtlasGridComponent } from '@ui/components/atlas-grid/atlas-grid.component';

@Component({
  selector: 'wsb-reseller-profile',
  templateUrl: './reseller-profile.component.html',
  styleUrls: ['./reseller-profile.component.scss'],
  standalone: false
})
export class ResellerProfileComponent implements OnInit, AfterViewChecked {
  @ViewChild('page', { static: true }) $page;
  @ViewChild('actionsBar', { static: true }) $actionsBar;
  @ViewChild('modalEdit') modalEdit;
  @ViewChild('modalDelete') modalDelete;
  @ViewChild(AtlasGridComponent) grid: AtlasGridComponent;
  editForm: UntypedFormGroup = null;
  sharingGroupForm: UntypedFormGroup = null;
  user: User | null;
  resellerProfileToEdit: ResellerProfile | null;
  resellerProfileToDelete: ResellerProfile | null;
  services = [];
  servicesBck = [];
  sharingGroup = false;
  sharingGroupBck = false;
  sharingTemplate = false;
  sharingTemplateBck = false;
  sharingBlacklist = false;
  sharingBlacklistBck = false;
  contactGroups: ContactGroups;
  blacklists: Blocklist;
  sharingGroupBuffer = [];
  sharingGrouppPage = 0;
  sharingBlacklistBuffer = [];
  sharingBlacklistPage = 0;
  numberOfItemsFromEndBeforeFetchingMore = 5;
  loadingSharingGroup = false;
  loadingSharingBlacklist = false;
  credits: any[] = [];
  creditsBck: any[] = [];
  templateList: SmsTemplate[];
  shareableUserBlackLists: any[] = [];
  constructor(
    private resellerService: ResellerService,
    private formBuilder: UntypedFormBuilder,
    private atlasToast: AtlasToastService,
    private router: Router,
    private smsService: SmsService,
    private route: ActivatedRoute,
    private contactService: ContactService,
    private location: Location,
    private elRef: ElementRef
  ) {}

  ngOnInit(): void {
    window.addEventListener('scroll', this.scroll, true);

    this.editForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      isDefault: [false],
      numSubaccount: [0],
      sharedGroups: [[]],
      sharedTemplates: [[]],
      sharedBlacklists: [[]]
    });
    if (!_.isNull(this.route.snapshot.paramMap.get('id'))) {
      this.resellerService.getProfile(this.route.snapshot.paramMap.get('id')).subscribe(data => {
        this.resellerProfileToEdit = data;
        if (data.sharedGroups.length) {
          this.sharingGroup = true;
          this.sharingGroupBck = true;
        }
        if (data.sharedTemplates.length) {
          this.sharingTemplate = true;
          this.sharingTemplateBck = true;
        }
        if (data.sharedBlacklists.length) {
          this.sharingBlacklist = true;
          this.sharingBlacklistBck = true;
        }
        this.editForm.patchValue(data);
        this.getActivableServices();
        this.getQualitySmsEnable();
      });
    } else {
      this.getActivableServices();
      this.getQualitySmsEnable();
    }
    this.fetchSharingGroup();
    this.fetchTemplatesList();
    this.contactService.getShareableUserBlackList().subscribe(data => {
      this.shareableUserBlackLists = data;
    });
  }

  ngAfterViewChecked(): void {
    this.displayScrollIndicator();
  }

  scroll = (): void => {
    this.displayScrollIndicator();
  };

  getQualitySmsEnable() {
    this.smsService.getMessageTypes().subscribe(data => {
      this.credits = data.data.map(x => {
        return {
          value: x.id,
          icon: creditsTypeIcon[x.id],
          title: x.label,
          enabled: false
        };
      });
    });

    this.credits.map(x => {
      x.enabled = x.enabled || _.includes(this.resellerProfileToEdit?.enabledSMSQualities, x.value);
    });
    this.creditsBck = this.credits.map(c => Object.assign({}, c));
  }

  getActivableServices() {
    this.resellerService.getActivableServices().subscribe(data => {
      this.services = data.map(x => {
        return {
          name: x,
          enabled: false
        };
      });
      // Force sms selected
      this.services.map(x => {
        x.enabled = x.enabled || x.name === 'sms' || _.includes(this.resellerProfileToEdit?.enabledServices, x.name);
      });
      this.servicesBck = this.services.map(s => Object.assign({}, s));
    });
  }

  smsEnabled(): boolean {
    const el = this.services.find(x => x.name === 'sms');
    return el && el.enabled;
  }

  changed(data: { value: string[] }) {}

  onScrollToEndSharingGroup() {
    this.fetchSharingGroup();
  }

  onScrollSharingGroup({ end }) {
    if (this.loadingSharingGroup) {
      return;
    }
    if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.sharingGroupBuffer.length) {
      this.fetchSharingGroup();
    }
  }

  private fetchSharingGroup() {
    if (!this.loadingSharingGroup) {
      this.sharingGrouppPage++;
      this.loadingSharingGroup = true;
      this.contactService.getGroups(this.sharingGrouppPage).subscribe(groups => {
        this.contactGroups = groups;
        if (groups.data.length) {
          this.sharingGroupBuffer = this.sharingGroupBuffer.concat(groups.data);
        } else {
          this.sharingGrouppPage--;
        }
        this.loadingSharingGroup = false;
      });
    }
  }

  private fetchTemplatesList() {
    this.smsService.getSmsTemplateList().subscribe(templates => {
      this.templateList = templates;
    });
  }

  resetForm() {
    if (!_.isNull(this.route.snapshot.paramMap.get('id'))) {
      this.reloadCurrentProfile();
    } else {
      this.resetNewProfile();
    }
  }

  private resetNewProfile() {
    this.editForm.reset();
    this.resetSharingRadioButton();
    // avoid calling BE
    this.reloadServicesItems();
    this.reloadCreditsItems();
  }

  private resetSharingRadioButton() {
    this.sharingGroup = false;
    this.sharingTemplate = false;
    this.sharingBlacklist = false;
  }

  private reloadCurrentProfile() {
    this.editForm.reset(this.resellerProfileToEdit);
    this.reloadSharingRadioButton();
    // avoid calling BE
    this.reloadServicesItems();
    this.reloadCreditsItems();
  }

  private reloadSharingRadioButton() {
    this.sharingGroup = this.sharingGroupBck;
    this.sharingTemplate = this.sharingTemplateBck;
    this.sharingBlacklist = this.sharingBlacklistBck;
  }

  private reloadServicesItems() {
    const old = this.servicesBck.map(s => Object.assign({}, s));
    this.services = [...old];
  }

  private reloadCreditsItems() {
    const old = this.creditsBck.map(s => Object.assign({}, s));
    this.credits = [...old];
  }

  submitForm() {
    this.editForm.disable();
    const raw = ResellerProfile.deserialize(this.editForm.getRawValue());
    raw.enabledServices = this.services.filter(x => x.enabled).map(x => x.name);
    raw.enabledSMSQualities = this.credits.filter(x => this.smsEnabled() && (x.enabled || this.credits.length <= 1)).map(x => x.value);
    if (this.resellerProfileToEdit) {
      raw.idSubaccountProfile = this.resellerProfileToEdit.idSubaccountProfile;
    }
    if (!this.sharingGroup) {
      raw.sharedGroups = [];
    }
    if (!this.sharingTemplate) {
      raw.sharedTemplates = [];
    }

    if (!this.sharingBlacklist) {
      raw.sharedBlacklists = [];
    } else {
      raw.sharedBlacklists = this.shareableUserBlackLists;
    }

    const op = this.resellerProfileToEdit
      ? this.resellerService.editProfile(this.resellerProfileToEdit, raw)
      : this.resellerService.addProfile(ResellerProfile.deserialize(raw));
    op.subscribe(
      data => {
        this.successOperation(data);
      },
      () => {
        this.errorOperation();
      },
      () => {}
    );
  }

  successOperation(data) {
    this.atlasToast.success('common_success', null);
    this.router.navigate(['/reseller/profiles']);
  }

  errorOperation() {
    this.atlasToast.error('common_error', null);
    this.editForm.enable();
  }
  onChangeEvent(ev) {
    this.editForm.markAsDirty();
  }

  goBack() {
    this.location.back();
  }

  private displayScrollIndicator() {
    if (!(this.$page && this.$actionsBar)) {
      return;
    }
    const $pageAccount: HTMLElement = this.$page.nativeElement;
    const $actionsBar: HTMLElement = this.$actionsBar.nativeElement;
    const $impersonateHeader: HTMLElement = document.getElementById('impersonate-header');

    if (!this.elRef.nativeElement || !this.elRef.nativeElement.closest('body')) {
      return;
    }

    const remainingHeight = window.innerHeight - $pageAccount.getBoundingClientRect().top;

    console.log($pageAccount.getBoundingClientRect().bottom - window.innerHeight);

    if (
      $pageAccount.clientHeight > remainingHeight + 5 &&
      $pageAccount.getBoundingClientRect().bottom - window.innerHeight - $impersonateHeader.getBoundingClientRect().bottom > 50
    ) {
      $actionsBar.classList.add('has--scroll-indicator');
    } else {
      $actionsBar.classList.remove('has--scroll-indicator');
    }
  }
}
